/*
 * Die Rückfragen der DATEV-Kopplung vor den Ein-Klick-Handgriffen (Entscheid 686, Hausregel „Bestätigung vor
 * Datenänderung“; Hausregel „durchgängig einheitliches Design“). „Ignorieren“ fragt wie die nächste Kreditornummer
 * (`RelationRoles.tsx`: Titel und Folge im Satz); „Übernehmen“ und „Zurücknehmen“ einer Zahlung wie „Bezahlt-Kennzeichen
 * zurücknehmen?“ an der Rechnung. Die Folgen stehen so in db/repositories/datevBooking.ts (`zahlungUebernehmen`,
 * `zahlungZuruecknehmen`: `paidAt` folgt dem Bruttobetrag). Die Nummernvergabe fragt mit `PARTNER_TEXT.confirmDebtorNext`
 * — dieselbe Frage wie unter Beziehungen. Schlüssel englisch, Werte deutsch.
 */
export const DATEV_TEXT = {
  ignoreTitle: (name: string): string => `${name} im Debitorenabgleich ignorieren?`,
  // Die Ignorierung gilt je Unternehmen auf Dauer (`datevDebtorIgnore`), auch für jeden späteren Abgleich.
  ignoreText: "Die Zeile erscheint danach in keinem Debitorenabgleich mehr, auch nicht nach dem nächsten Einlesen.",
  ignore: "Ignorieren",
  adoptTitle: (invoiceNumber: string): string => `Zahlung zu Rechnung ${invoiceNumber} übernehmen?`,
  adoptText: (betrag: string, datum: string): string => `Die Buchung über ${betrag} vom ${datum} wird der Rechnung als `
    + "Zahlung zugerechnet. Deckt sie den Bruttobetrag, steht die Rechnung danach als bezahlt in der Liste.",
  adopt: "Übernehmen",
  withdrawTitle: (invoiceNumber: string): string => `Zahlung zu Rechnung ${invoiceNumber} zurücknehmen?`,
  withdrawText: (betrag: string): string => `Die übernommene Zahlung über ${betrag} wird von der Rechnung zurückgenommen. `
    + "Unterschreitet der Rest den Bruttobetrag, steht die Rechnung danach wieder als offen in der Liste.",
  withdraw: "Zurücknehmen",
};
